'use client'
interface TextButtonProps {
  text: string
  size?: number
  onClick: () => void
  disabled?: boolean
  className?: string
}
const TextButton = ({ text, size = 16, onClick, disabled = false, className }: TextButtonProps) => {
  return (
    <button className={`fs ${className}`} onClick={onClick} disabled={disabled} style={{ "--fs": size } as React.CSSProperties}>
      {text}
    </button>
  )
}

export default TextButton
